import Controller from '../components/Controller';

/**
 * 编辑器控制器
 */
export default class TopoEditorController extends Controller {
    /**
     * 构造方法，初始化控制器
     * @param   {object}    可选项
     * @returns {undefined}
     */
    constructor(options) {
        super(options);

        /**
         * 当前可用的编辑器
         * @type {object}
         */
        this.activeEditor = null;
    }

    /**
     * 删除编辑器
     * @param {object} topoEditor 编辑器实例
     * @return {undefined}
     */
    delete(topoEditor = this.activeEditor) {
        if (this.activeEditor && this.activeEditor === topoEditor) {
            this.activeEditor = null;
        }

        super.delete(topoEditor);
    }

    /**
     * 添加编辑器
     * @param {Object} topoEditor 编辑器实例
     * @return {undefined}
     */
    startEditor(topoEditor) {
        if (this.activeEditor && this.activeEditor !== topoEditor) {
            this.activeEditor.stop();
        }

        this.activeEditor = topoEditor;
    }
}
